import { createContext, useContext } from 'react';
import { SearchManagerContextType } from './types';

export const initialSearchResults = {
  flows: { data: [], total: 0 },
  jobs: { data: [], total: 0 },
  contacts: { data: [], total: 0 },
  interviews: { data: [], total: 0 },
};

const SearchManager = createContext<SearchManagerContextType>({
  searchTerm: '',
  setSearchTerm: () => {},
  isSearchLoading: false,
  setIsSearchLoading: () => {},
  onSearchClose: () => {},
  searchResults: initialSearchResults,
  setSearchResults: () => {},
  selected: 0,
  setSelected: () => {},
  modalContainerRef: null,
  setSearchText: () => {},
  handleKeyboardEnter: () => {},
  handleKeyboardNavigation: () => {},
  currentTab: 'contacts',
  setCurrentTab: () => {},
  handleKeyDown: () => {},
  includeResume: false,
  setIncludeResume: () => {},
});

SearchManager.displayName = 'SearchManager';

export const useSearchManager = () => {
  const SearchManagerContext = useContext(SearchManager);
  return SearchManagerContext;
};

export const SearchManagerProvider = SearchManager.Provider;
